module.exports = __webpack_public_path__ + "static/media/displaygroup-2.b6005e3d.jpg";